// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2ofLz","file":"styles_file__Q96Er"};